export function initializeAccessibleVideos() {
  const videos = [...document.querySelectorAll("[data-managed-video]")];

  if (videos.length === 0) return;

  const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

  videos.forEach((video) => {
    const container = video.parentElement;
    const toggle = container?.querySelector("[data-video-toggle]");

    if (!toggle) return;

    const playIcon = toggle.querySelector("[data-video-play-icon]");
    const pauseIcon = toggle.querySelector("[data-video-pause-icon]");
    const label = toggle.dataset.videoLabel || "video";
    let isVisible = false;
    let userPaused = false;
    let userStarted = false;

    video.defaultMuted = true;
    video.muted = true;
    video.volume = 0;
    toggle.hidden = false;

    const updateToggle = () => {
      const isPlaying = !video.paused && !video.ended;

      toggle.setAttribute("aria-label", `${isPlaying ? "Pause" : "Play"} ${label}`);
      playIcon?.classList.toggle("hidden", isPlaying);
      pauseIcon?.classList.toggle("hidden", !isPlaying);
    };

    const play = () => {
      video.muted = true;
      void video.play().catch(updateToggle);
    };

    const syncPlayback = () => {
      const playbackAllowed = !reducedMotion.matches || userStarted;

      if (isVisible && playbackAllowed && !userPaused) {
        play();
      } else {
        video.pause();
        updateToggle();
      }
    };

    const observer = new IntersectionObserver(
      ([entry]) => {
        isVisible = entry.isIntersecting;
        syncPlayback();
      },
      { threshold: 0.2 },
    );

    toggle.addEventListener("click", () => {
      if (video.paused || video.ended) {
        userPaused = false;
        userStarted = true;
        play();
      } else {
        userPaused = true;
        video.pause();
        updateToggle();
      }
    });

    video.addEventListener("play", updateToggle);
    video.addEventListener("pause", updateToggle);
    video.addEventListener("ended", updateToggle);
    reducedMotion.addEventListener("change", syncPlayback);
    observer.observe(video);
    updateToggle();
  });
}
